import $ from 'jquery';
import './bootstrap';
import { initGoogleSearchPlaceholder } from './components/google-search.js';
import { initOpenCampusBanner } from './components/opencampus-banner-sticky.js';
window.$ = $;
document.addEventListener('DOMContentLoaded', async () => {
    initGoogleSearchPlaceholder();
    const headerEl = document.getElementById('header');
    if (headerEl) {
        const { scrollHeader, controlMenu, controlShow } = await import('./components/header.js');
        controlShow();
        controlMenu();
        $(window).on('load scroll resize', function () {
            scrollHeader();
        });
    }

    const { scrollBubble } = await import('./components/scroll.js');
    scrollBubble();

    const { scrollNavi, scrollBackToTop } = await import('./components/scroll-sticky-bottom.js');
    scrollNavi();
    scrollBackToTop();

    initOpenCampusBanner();

    const { initAnchorLinkDirect } = await import("./components/anchorlink.js");
    initAnchorLinkDirect(false);

    const textMarqueeElm = document.getElementById("js-marquee");
    const textMarqueeReverseElm = document.getElementById("js-marquee-reverse");
    const { renderMarqueeTtl } = await import("./components/slider.js");
    renderMarqueeTtl(textMarqueeElm);
    renderMarqueeTtl(textMarqueeReverseElm, true);

    const { initAccordionFooter } = await import('./components/accordion.js');
    initAccordionFooter();

    const { initLanguageLabel } = await import('./components/language-label.js');
    initLanguageLabel();

});
